import React from "react";
import {
    Badge,
    Box,
    Grid,
    List,
    ListItem,
    Typography,
    useToastProvider
} from '@deere/fuel-react';
import {Link} from "react-router-dom";
import WarningIcon from "@material-ui/icons/Warning";
import {SendReminderModal} from "../shared/modal/SendReminderModal";
import {useAuthConfig} from '../shared/helper';
import {Chip} from "@material-ui/core";
import {NOT_YET_PUBLISHED} from "../shared/Constants";

export const RatingsCampaign = (data, index = 0) => {
    let authAxios = useAuthConfig();
    const {enqueueToast} = useToastProvider();

    const handleSendReminder = (campaignId) => {
        authAxios.post(`/campaign/reminder/${campaignId}`)
            .then(res => {
                enqueueToast({
                    variant: "success",
                    title: "Reminder email sent",
                    isCloseable: true
                });
            }).catch((error) => {
            enqueueToast({
                variant: "error",
                title: "System Error",
                message: error.response ? error.response.data[error.response.status] : "",
                isPersistent: true
            });
        });
    }

    return (
        <Grid container key={index}>
            <Grid item xs={12}>
                <List key={index}>
                    {data.item.campaigns.map(campaignsData => {
                        const percentage = Math.round((campaignsData.respondedFeedbacks / campaignsData.totalFeedbacks) * 100)
                        return (
                            <ListItem divider style={{padding: '.5rem'}} key={campaignsData.campaignId}>
                                <Grid container>
                                    <Grid item xs={12} md={8}>
                                        {campaignsData.status === "Y" ? (
                                            <Link
                                                to={{
                                                    pathname: `/campaigns/summary/${campaignsData.campaignId}`
                                                }} target="_blank">
                                                {campaignsData.title}
                                            </Link>
                                        ) : (
                                            <Link
                                                to={{
                                                    pathname: `/campaigns/edit-campaign/${campaignsData.campaignId}`
                                                }} target="_blank">
                                                {campaignsData.title}
                                            </Link>
                                        )}
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <Box display="flex" justifyContent="flex-end">
                                            {campaignsData.status === "N" &&
                                            <Chip size="small" icon={<WarningIcon style={{fill: "#F99700"}}/>}
                                                  label={NOT_YET_PUBLISHED} style={{backgroundColor: "#fee7c4", fontWeight: 600, borderRadius: ".5rem"}}/>
                                            }
                                            {campaignsData.status === "Y" && (
                                                <Box>
                                                    <Badge variant={campaignsData.feedbackOpen ? "success" : "error"}>{campaignsData.feedbackOpen ? "Accepting Feedback" : "Feedback Closed"}</Badge>
                                                    <Typography variant="label" display="inline"
                                                                style={{marginRight: "0.5rem", marginLeft: "2px"}}>
                                                        Responses
                                                    </Typography>
                                                    <Typography variant="body2" display="inline">
                                                        {campaignsData.respondedFeedbacks}/{campaignsData.totalFeedbacks} ({percentage}%)
                                                    </Typography>
                                                </Box>
                                            )}
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} md={7}>
                                        <Typography variant="label" display="inline" style={{marginRight: "0.25rem"}}>
                                            Created By
                                        </Typography>
                                        <Typography component="span" variant="body2">
                                            {campaignsData.campaignOwner} - {campaignsData.createdBy}
                                        </Typography>
                                    </Grid>
                                    {(campaignsData.status === "Y" && (campaignsData.respondedFeedbacks < campaignsData.totalFeedbacks)) && campaignsData.feedbackOpen ?
                                        <Grid item xs={12} md={2}>
                                            <Box display="flex" justifyContent="flex-end">
                                                <SendReminderModal campaignId={campaignsData.campaignId}
                                                                   onSave={() => {
                                                                       handleSendReminder(campaignsData.campaignId)
                                                                   }}/>
                                            </Box>
                                        </Grid> : <Grid item xs={12} md={2}/>
                                    }
                                    <Grid item xs={12} md={3}>
                                        <Box display="flex" justifyContent="flex-end">
                                            <Typography variant="label" display="inline"
                                                        style={{marginRight: "0.5rem"}}>
                                                Due Date
                                            </Typography>
                                            <Typography variant="body2">
                                                {campaignsData.responseByTs}
                                            </Typography>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </ListItem>
                        )
                    })
                    }
                </List>
            </Grid>
        </Grid>
    )
}
